import styled from "styled-components";
import colors from "modules/colors";
import { Flex } from "@rebass/grid";

export const InputGroup = styled(Flex)`
  border-bottom: 1px solid ${() => colors.grey};
`;
